import * as api from "./client.js";

export type LanguagesResponse = {
  langInputs: string[];
  langOutputs: string[];
  requestId?: string;
};

export const languages = {
  getDistinct: async (edition?: string): Promise<LanguagesResponse> => {
    const params = new URLSearchParams();
    if (edition) params.append("edition", edition);

    const query = params.toString() ? `?${params.toString()}` : "";
    return api.get<LanguagesResponse>(`/v1/approval/approval-requests/languages${query}`);
  },
};
